// Module
var code = "<nlg-tag-input name=nlgMultiSelect ng-model=model format-tag=formatTag(tag) get-tags=options></nlg-tag-input>";
// Exports
module.exports = code;